export default class CookieCategory {
    public title :string = '';
    public description: string = '';
    public cookieName : string = '';
    public isRequired: boolean = true;
    public hasConcent: boolean = false;
} 